import React, { useState, useEffect, useCallback } from "react";
import EventsGalleryService from "../../services/EventsGalleryService";
import Loadspinner from "../../common/Loadspinner"
import Main from "../../common/Main/Main";
import ImageViewer from "react-simple-image-viewer";
import { downloadBlob } from "../../services/CommonService";
import LoadMoreImage from "./LoadMoreImage";
import ImageLightBox from "./ImageLightBox";
import './style.css';
// import { Link } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import useKeyPress from "./useKeyPress";
import { APICall } from "../../helpers/API/APICalls";
import { getAllEventGalleryData, getAllEventGalleryMasterData } from "../../helpers/API/APIEndPoints";
import LoadMoreImage2 from "./LoadMoreImage2";
import Modal from '@mui/material/Modal';
import EventGalleryEdit from "../../Pages/Masters/EventGallery/EventGalleryEdit";
import { ic_broken_image } from "../../constants/Images";
import { replaceImgAccountName } from "../../helpers/Utils/Utils";

const EventGallery2 = () => {
  const [loading, setLoading] = useState(false);
  const [eventsGalleryList, setEventsGalleryList] = useState({});
  const [currentImage, setCurrentImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(null);
  const [currentGalleryId, setCurrentGalleryId] = useState(null);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [, setImageUrl] = useState([]);
  const [imageViewerUrl, setImageViewerUrl] = useState([])
  const [imageLightUrl, setImageLightUrl] = useState('');
  const [currentImageEventName, setCurrentImageEventName] = useState('');
  const rightPress = useKeyPress("ArrowRight");
  const leftPress = useKeyPress("ArrowLeft");

  const [pageSize, setPageSize] = useState(Number.MAX_SAFE_INTEGER);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("Sequence");
  const [sortDirection, setSortDirection] = useState("asc");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  const [eventGalleryData, setEventsGalleryData] = useState([]);


  const openImageViewer2 = useCallback(async (galleryId, docId, eventName, imgIndex) => {
    //const filterUrl = imageViewerUrl.filter(el => el.split('/')[5].split('?')[0] === index)[0]
    //const imgIndex = imageViewerUrl.indexOf(filterUrl);
    const currGalleryArr = eventGalleryData.find(egd => egd.key == galleryId);
    //   console.log(currGalleryArr,"cur");
    if (currGalleryArr) {
      const currImageDoc = currGalleryArr.values.find(cga => cga.docId == docId);
      if (currImageDoc) {
        const buildImageUrl = await downloadBlob(currImageDoc.docUrl);
        //console.log(buildImageUrl, "img");
        setImageLightUrl(buildImageUrl);
        setCurrentImage(buildImageUrl);
        setIsViewerOpen(true);
        setCurrentImageEventName(eventName);
        setCurrentImageIndex(imgIndex);
        setCurrentGalleryId(galleryId);
      }
    }
  }, [currentImage, imageViewerUrl, eventGalleryData]);

  const closeImageViewer = () => {
    setCurrentImage(null);
    setIsViewerOpen(false);
  };


  useEffect(() => {
    getEventGalleriesV2()

  }, []);

  // useEffect(() => {
  //   isViewerOpen &&
  //     openNextImage()


  // }, [rightPress]);

  // useEffect(() => {
  //   isViewerOpen &&
  //     openPrevImage()
  // }, [leftPress]);




  const getEventGalleriesV2 = async () => {
    let requestParams = {
      start: start,
      resultsPerPage: pageSize,
      searchText: searchText,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      isExport: false,
    };
    //console.log(requestParams);
    let res = await APICall(getAllEventGalleryData, requestParams);
    if (res.message === "Ok") {
      // if (res && res.data.length > 0 && res.totalCount > 0) {
      if (res && res.data.length > 0) {
        // const imgViewerUrls = [];
        // for (let index = 0; index < res?.data?.length; index++) {
        //   const img = res?.data?.[index];

        //   const imgUrl = await downloadBlob(img.docUrl);
        //   imgViewerUrls.push(imgUrl);
        // }
        // setImageUrl(imgViewerUrls);
        // setImageViewerUrl(imgViewerUrls);
        let oldData = res.data;
        oldData.forEach(od =>
          replaceImgAccountName(od?.docUrl)
        );
        let newData = groupByArray(oldData, 'id', 'Name');
        setEventsGalleryData(newData);
        setCount(res.data.length);
      } else {
        setEventsGalleryData([]);
        setCount(0);
      }
    } else {
      setEventsGalleryData([]);
      setCount(0);
    }
  }
  //console.log(eventGalleryData)
  const groupByArray = (xs, key, extra = null) => {
    return xs.reduce(function (rv, x) {
      let v = key instanceof Function ? key(x) : x[key];
      let el = rv.find((r) => r && r.key === v);
      if (el) {
        el.values.push(x);
      } else {
        let newObj = { key: v, values: [x] };
        if (extra) {
          newObj[extra] = extra instanceof Function ? extra(x) : x[extra];
        }
        rv.push(newObj);
      }
      return rv;
    }, []);
  }

  const openNextImage = async () => {
    const nextIndex = currentImageIndex + 1;
    setCurrentImageIndex(prevCount => prevCount + 1);
    const imgUrl = eventGalleryData?.find(egd => egd.key == currentGalleryId)?.values?.[nextIndex]?.docUrl;
    if (imgUrl) {
      const buildImageUrl = await downloadBlob(imgUrl);
      setImageLightUrl(buildImageUrl);
    }
  }
  const openPrevImage = async () => {
    const nextIndex = currentImageIndex - 1;
    setCurrentImageIndex(prevCount => prevCount - 1);
    const imgUrl = eventGalleryData?.find(egd => egd.key == currentGalleryId)?.values?.[nextIndex]?.docUrl;
    if (imgUrl) {
      const buildImageUrl = await downloadBlob(imgUrl);
      setImageLightUrl(buildImageUrl);
    }
  }

  return (
    <>
      <Main active={"eventgallery"}>
        <Loadspinner filename="EventGallery2.js" isLoading={loading} isMiddle="false" />
        <h5 style={{ marginBottom: "15px", marginTop: '15px' }}>Event Gallery</h5>
        <div style={{ marginBottom: '50px' }}>

          {eventGalleryData.map((item, itemIndex) => {
            return <div key={`key_${itemIndex}`}>
              <span style={{ fontWeight: '500' }}>{item.Name}</span>
              <div className="row">

                <LoadMoreImage2
                  openImageViewer={openImageViewer2}
                  id={item.key}
                  images={item.values}
                  key={`key_${itemIndex}`}
                  eventName={item.Name} item={item} />

                {/* <Link to={`/eventgallery/${item}`} className="viewMore" >View More</Link> */}

              </div>
              {isViewerOpen && !isViewerOpen && (
                <ImageViewer
                  src={imageViewerUrl}
                  currentIndex={currentImage}
                  onClose={closeImageViewer}
                  disableScroll={false}
                  backgroundStyle={{
                    backgroundColor: "rgba(0,0,0,0.9)"
                  }}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = ic_broken_image;
                  }}
                  width='80'
                  closeOnClickOutside={true}
                />
              )}
            </div>

          }

          )}

        </div>
      </Main>
      <Modal
        open={isViewerOpen}
        onClose={setIsViewerOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.9)' }}
      >
        <div className="modal-parent-div">
          <div onClick={() => setIsViewerOpen(false)} style={{
            position: 'absolute',
            top: 10,
            right: 10,
            zIndex: 100,
            cursor: 'pointer',
            color: 'whitesmoke'
          }}><CloseIcon /></div>
          {eventGalleryData?.find(egd => egd.key == currentGalleryId)?.values?.[currentImageIndex]?.docExtension?.startsWith('video') ?
            <video src={imageLightUrl} className="fullscreenVideo" controls
              alt={eventGalleryData?.find(egd => egd.key == currentGalleryId)?.values?.[currentImageIndex]?.docName} /> :
            <img src={imageLightUrl}
              alt={eventGalleryData?.find(egd => egd.key == currentGalleryId)?.values?.[currentImageIndex]?.docName}
              style={{
                height: '94vh',
                width: 'auto',
                marginLeft: 'auto',
                marginRight: 'auto',
                display: 'block',
                marginTop: '40px'
              }}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = ic_broken_image;
              }}
              onLoad
            />
          }
          {currentImageIndex < eventGalleryData?.find(egd => egd.key == currentGalleryId)?.values?.length - 1 &&

            <div onClick={openNextImage} style={{
              position: 'absolute',
              top: '50%',
              right: 10,
              zIndex: 100,
              cursor: 'pointer',
              color: 'whitesmoke'
            }}><ArrowForwardIosIcon /></div>}

          {currentImageIndex > 0 && <div onClick={openPrevImage} style={{
            position: 'absolute',
            top: '50%',
            left: 10,
            zIndex: 100,
            cursor: 'pointer',
            color: 'whitesmoke'
          }}><ArrowBackIosNewIcon /></div>}
        </div>
      </Modal>
      {isViewerOpen && <ImageLightBox isImageOpen={false} src={imageLightUrl} alt='iamge'>
        <div onClick={() => setIsViewerOpen(false)} style={{
          position: 'absolute',
          top: 10,
          right: 10,
          zIndex: 100,
          cursor: 'pointer',
          color: 'whitesmoke'

        }}><CloseIcon /></div>
        {currentImageIndex < eventGalleryData?.find(egd => egd.key == currentGalleryId)?.values?.length - 1 && <div onClick={openNextImage} style={{
          position: 'absolute',
          top: '50%',
          right: 10,
          zIndex: 100,
          cursor: 'pointer',
          color: 'whitesmoke'
        }}><ArrowForwardIosIcon /></div>}

        {currentImageIndex > 0 && <div onClick={openPrevImage} style={{
          position: 'absolute',
          top: '50%',
          left: 10,
          zIndex: 100,
          cursor: 'pointer',
          color: 'whitesmoke'
        }}><ArrowBackIosNewIcon /></div>}
      </ImageLightBox>}
    </>
  );
}

export default EventGallery2;
